// Category filters mapped to Shopify tags
export const CATEGORY_TAGS = {
    Lighting: "Category_Lighting",
    Suspension: "Category_Suspension",
    Armor: "Category_Armor",
    Accessories: "DMM accessories",
    Mounts: "DMM", // Shopify uses “DMM” tag for Mounts
    Apparel: "Category_Apparel",
    TGMade: "tgmade",
    // ❌ No "Top Sellers" here → handled separately by TOP16
    // ❌ Recovery removed: no products tagged in Shopify
  };
  
  // Generation filters mapped to Shopify tags
  export const GENERATION_TAGS = {
    "1st Gen": "Generation_1st",
    "2nd Gen": "Generation_2nd",
    "3rd Gen": "Generation_3rd",
    "4th Gen": "Generation_4th",
  };
  